import { getQuery } from 'sutils';
import ua from '@tencent/docs-user-agent';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import ENV from '../../runtime-environment/enviroment';

/**
 * 是否使用webgl处理filter
 * @return {boolean}
 */
export function isWebglRenderFilter(): boolean {
    const query = getQuery('webglFilter');
    return query !== '0';
}

let isSupportWebgl = true;
// 查看是否支持Webgl并开启了硬件加速
export function checkIfChromeAccelerated(): boolean {
    if (window?.isInWorker) {
        isSupportWebgl = false;
        return false;
    }
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl');
    if (!gl) {
        isSupportWebgl = false;
        return false;
    }

    let accelerated = false;
    const debugInfo = gl.getExtension?.('WEBGL_debug_renderer_info');
    if (debugInfo) {
        const renderer = gl.getParameter?.(debugInfo.UNMASKED_RENDERER_WEBGL);
        accelerated = renderer?.indexOf('SwiftShader') === -1;
    }
    return accelerated;
}

function checkFilterSupport(): boolean {
    if (window?.isInWorker) {
        return false;
    }
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('2d');

    if (!gl) return false;

    return gl.filter?.length > 0;
}

// 是否使用webgl渲染滤镜
const webglRenderFilter = isWebglRenderFilter();
const isSupportFilter = checkFilterSupport();

export const CANVAS_EDIT_MODE = false; // 编辑层开关
export const CANVAS_ANIM_USE_CACHE = false; // 动画元素是否使用开启缓存，默认false

// 禁用webgl滤镜
export const FORBID_WEBGL_FILTER = !webglRenderFilter || isSupportFilter; // 支持filter优先使用filter，目前filter性能更好

// 开启图表渲染，不走兜底图
export const ENABLE_CHART_RENDER = true;

// 开启 WebChimera 视频播放器来渲染视频元素
export const ENABLE_WCJS_VIDEO_PLAYER_RENDERER = !!ENV.IS_PC_LOCAL_EDIT && ua.isMac // 仅本地编辑桌面端开启，Web 端需要屏蔽
    && ua.isElectronTencentDocsClientVersionAboveOrEqual('3.6.1'); // 3.6.2 版本以上支持本地视频播放，低版本不支持

// 开启选择性粘贴
export const ENABLE_PASTE_SPECIAL = browser.isPc;

// 开启AI指令
export const OPEN_AI_COMMAND = false;
